import React from 'react';
import Paper from 'material-ui/Paper';
import Divider from 'material-ui/Divider';
import { cdnPath } from '../constants/config';




class NonMedicalBenefits extends React.Component {
    
    render() {

        const style = {
            labels:{
                fontSize: "11pt",
                color: "#828282",
            },
            data:{
                fontSize: "11pt",
                fontWeight: 600,
                color: "#333333",
            },
            lightText: {
                color: "#999999",
            }
        }

        return (

            <div>
                <div>
                    {this.props.plan.Networks[0].LogoUrl && (
                        <div>
                            <img src={`https://${cdnPath}/networkimages/` + this.props.plan.Networks[0].LogoUrl} style={{height:40, paddingBottom: 5}} />
                            <Divider style={{ width: '100%', margin:'5px 0 5px 0' }} />
                        </div>
                    )}
                    {!this.props.plan.Networks[0].LogoUrl && (
                        <div>
                            <h3>{this.props.plan.Networks.length > 0 ? `Network: ${this.props.plan.Networks[0].Name}` : `Plan: ${this.props.plan.Name}`}</h3>
                            <Divider style={{ width: '100%', margin:'5px 0 5px 0' }} />
                        </div>
                    )}
                    
                    <table>
                        <tbody>
                        <tr style={{height: 34}}>
                            <td><span className={"truenoLight"} style={style.labels}>Network</span></td>
                            <td><span className={"trueno semiBold"} style={style.data}>{this.props.plan.Networks[0].Name}</span></td>
                        </tr>
                        <tr style={{height: 34}}>
                            <td><span className={"truenoLight"} style={style.labels}>Plan</span></td>
                            <td><span className={"trueno  semiBold"} style={style.data}>{this.props.plan.Name}</span></td>
                        </tr>
                        <tr style={{height: 34}}>
                            <td><span className={"truenoLight"} style={style.labels}>Member #</span></td>
                            <td><span className={"trueno  semiBold"} style={style.data}>{this.props.plan.ClientUserPlan.MemberID}</span></td>
                        </tr>
                        <tr style={{height: 34}}>
                            <td><span className={"truenoLight"} style={style.labels}>Group #</span></td>
                            <td><span className={"trueno semiBold"} style={style.data}>{this.props.plan.ClientUserPlan.GroupID}</span></td>
                        </tr>
                        </tbody>
                    </table>

                </div>
            </div>

        );
    }
};

export default NonMedicalBenefits;




// WEBPACK FOOTER //
// ./src/Components/NonMedicalBenefits.js